import type { RuleVotes as RuleVotesData } from "@reviewer73/shared";
import { ThumbsDown, ThumbsUp } from "lucide-react";

type RuleVotesProps = {
  votes: RuleVotesData;
};

export function RuleVotes({ votes }: RuleVotesProps) {
  if (votes.up === 0 && votes.down === 0) return null;
  return (
    <span
      className="inline-flex items-center gap-2"
      title="Rückmeldungen auf Findings dieser Regel: 👍/👎 als Reaktion auf das Finding"
    >
      <span className="inline-flex items-center gap-1">
        <ThumbsUp className="size-3.5" aria-label="hilfreich" />
        {votes.up}
      </span>
      <span className="inline-flex items-center gap-1">
        <ThumbsDown className="size-3.5" aria-label="nicht hilfreich" />
        {votes.down}
      </span>
    </span>
  );
}
